import {
  ActionLogRepositoryInterface,
  SearchActionLogsOptions,
  SearchActionLogsResponse,
} from "./interfaces";

import { AxiosInstance } from "axios";
import moment from "moment";

function formatRFC3339(dateString: string): string {
  return moment(dateString).format("YYYY-MM-DDTHH:mm:ssZ");
}

export default class ActionLogRepository
  implements ActionLogRepositoryInterface
{
  public static BaseURL = "/logs";

  constructor(private readonly axios: AxiosInstance){}

  public search(
    options: SearchActionLogsOptions
  ): Promise<SearchActionLogsResponse> {
    const params = {
      page: options.page,
      page_size: options.page_size,

      service_ids: joinCsv(options.service_ids),
      actions: joinCsv(options.actions),
      agents: joinCsv(options.agents),
      results: joinCsv(options.results),

      start_time: options.start_time && formatRFC3339(options.start_time),
      end_time: options.end_time && formatRFC3339(options.end_time),

      sort: options.sort,
    };

    return this.axios
      .get(ActionLogRepository.BaseURL, { params })
      .then((response) => response.data);
  }
}

function joinCsv(values?: string[]): string | undefined {
  if (!values || values.length === 0) {
    return undefined;
  }

  const trimmed = values.map((value) => value.trim()).filter(Boolean);
  return trimmed.length > 0 ? trimmed.join(",") : undefined;
}
